import * as type from './types';

export function registerPersonal(data) {
    return {
      type: type.POST_REGISTER_PERSONAL_REQUESTED,
      data:data,
    }
  }

export function clearRegisterPersonalError() {
    return {
      type: type.CLEAR_REGISTER_PERSONAL_ERROR,
    }
  }